var module = angular.module('octopusApp.configuration');

module.controller('SmtpEditController', function($scope, $location, $state, busy, pageTitle, octopusRepository, octoDialog, unsavedChanges) {
  var isLoading = $scope.isLoading = busy.create();
  var isSaving = $scope.isSaving = busy.create();

  $scope.view = {};
  $scope.view.hasExistingPassword = false;
  $scope.view.showPasswordChange = false;

  isLoading.promise(octopusRepository.SmtpConfiguration.get().then(function (smtp) {
    $scope.smtp = smtp;
    if (!smtp.SmtpLogin) {
      $scope.view.showPasswordChange = true;
    } else {
      $scope.view.hasExistingPassword = true;
    }
  }));

  $scope.save = function(sendTestEmail) {
    isSaving.promise(octopusRepository.SmtpConfiguration.modify($scope.smtp).then(function (result) {
      unsavedChanges.saved();
      if (!sendTestEmail) {
          $state.reload();
        return;
      }

      octoDialog.prompt({
        title: "Test email",
        message: "Who would you like to send the test email to?",
        answer: "test@test.com",
        executeButtonText: "Send",
        executeButtonClass: "btn-success",
        execute: function(dialog) {
          var task = {
            Name: 'TestEmail',
            Description: 'Send test email',
            Arguments: { EmailAddress: dialog.answer }
          };

          dialog.busy.promise(octopusRepository.Tasks.create(task).then(function(result){
            dialog.dismiss();
            $location.path("/tasks/" + result.Id);
          }));
        }
      });
    }));
  };
});








//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/smtp/controllers/smtp_edit_controller.js
// module id = 6256137978928058
// module chunks = 1